// Function to get a URL parameter
function getUrlParameter(name) {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    var results = regex.exec(location.search);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
}

// Function to set a cookie
function setCookie(name, value, days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

// Function to get a cookie
function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}
function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if(summary.nextElementSibling && summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};
//console.log("method",method,"params",params); return false;
  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
     var posterId=poster.id;
  //   if(poster.dataset){
  //     console.log("HHHEEEEEREE",poster.dataset)
  //   var posterId=poster.id;
  //   poster.addEventListener('mouseover', this.loadContent.bind(this,posterId));
  //   }
  // else {  console.log("WWHEHEHEH")
    poster.addEventListener('click', this.loadContent.bind(this,posterId));
  //}
  }

  loadContent(posterId='',focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

    this.setAttribute('loaded', true);
    const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      
   if (deferredElement && deferredElement.tagName === "VIDEO") {
        deferredElement.setAttribute("playsinline", ""); // Ensure iOS inline play
        deferredElement.muted = true; // iOS requires muted video
        deferredElement.autoplay = true; // Autoplay once clicked
        deferredElement.loop = true;
        deferredElement.controls = true;

        // Play the video with a promise to handle any iOS errors
        deferredElement.play().catch(error => {
          console.error("iOS prevented autoplay, attempting alternative method:", error);
          deferredElement.muted = true; // Ensure it's muted for iOS play
          deferredElement.play(); // Try again
        });
      }

    if (focus)deferredElement.focus();
    var videoId=posterId.split("-");  
    if(posterId){
    var videoId=posterId.split("-");
   if(videoId[2] =='Vimeo'){
   }
   else {
    var videoSection=document.querySelector('[data-media-id="'+videoId[3]+'"]').querySelector('video');
   }
    /*videoSection.addEventListener('mouseleave', function(){  console.log("NSTOP");
       videoSection.pause();
    });
    videoSection.addEventListener('mouseover', function(){videoSection.play(); });
    */
    }
  
    }    
    else {
      console.log("NOT LOADED");
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    // Filter out slides that are not hidden
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => {
      return getComputedStyle(element).display !== 'none' && element.clientWidth > 0;
    });

    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    this.updateButtonStates();
  }

  updateButtonStates() {
    const firstVisibleSlide = this.sliderItemsToShow[0];
    const lastVisibleSlide = this.sliderItemsToShow[this.sliderItemsToShow.length - 1];

    if (this.isSlideVisible(firstVisibleSlide) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(lastVisibleSlide)) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    const nextVisibleSlide = this.findNextVisibleSlide(this.currentPage, event.currentTarget.name === 'next' ? 1 : -1);

    if (nextVisibleSlide !== null) {
      this.slideScrollPosition = nextVisibleSlide.offsetLeft;
      this.slider.scrollTo({
        left: this.slideScrollPosition
      });
    }
  }

  findNextVisibleSlide(currentPage, direction) {
    const visibleSlides = this.sliderItemsToShow;
    const currentIndex = currentPage - 1;

    let newIndex = currentIndex + direction;
    while (newIndex >= 0 && newIndex < visibleSlides.length) {
      if (getComputedStyle(visibleSlides[newIndex]).display !== 'none') {
        return visibleSlides[newIndex];
      }
      newIndex += direction;
    }
    return null; // No more visible slides in that direction
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  refreshSlides() {
    this.resetPages(); // Reset and recalculate the slides and pagination
    this.setSlideVisibility(); // Update visibility based on current page
    this.updateButtonStates(); // Update the previous and next buttons
    this.update(); // Ensure the current state is reflected properly
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  linkToSlide(event) {
    event.preventDefault();

    const slideIndex = this.sliderControlLinksArray.indexOf(event.currentTarget); // Get the index of the clicked link
    if (slideIndex === -1) return;

    // Update current page before scrolling
    this.currentPage = slideIndex + 1;

    // Scroll to the correct slide
    const slideScrollPosition = this.sliderFirstItemNode.clientWidth * slideIndex;
    this.slider.scrollTo({
      left: slideScrollPosition,
      behavior: 'smooth',
    });

    // Update visibility and button states after scrolling
    this.setSlideVisibility();
    this.updateButtonStates();
  }

  setSlideVisibility() {
    const sliderWidth = this.slider.offsetWidth;
    const scrollLeft = this.slider.scrollLeft;

    // Dynamically calculate the visible slide based on scroll position
    this.sliderItemsToShow.forEach((item, index) => {
      const itemLeft = item.offsetLeft;
      const itemRight = itemLeft + item.offsetWidth;

      const isVisible = itemLeft >= scrollLeft && itemRight <= scrollLeft + sliderWidth;

      if (isVisible) {
        this.currentPage = index + 1; // Update the current page to the visible slide
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });

    // Update the active state of slide counter links
    this.update();
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slider.scrollTo({
        left: this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length,
        behavior: 'smooth',
      });
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slider.scrollTo({
        left: 0,
        behavior: 'smooth',
      });
    }
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (!this.autoplayButtonIsSetToPlay || event.target === this.sliderAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    if (event.target === this.sliderAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const nextVisibleSlide = this.findNextVisibleSlide(this.currentPage, 1);
    if (nextVisibleSlide) {
      this.slider.scrollTo({
        left: nextVisibleSlide.offsetLeft,
        behavior: 'smooth',
      });
    } else {
      this.slider.scrollTo({
        left: 0,
        behavior: 'smooth',
      });
    }
  }
}

customElements.define('slideshow-component', SlideshowComponent);


class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() { 
   
    this.updateOptions();
    this.updateTaxPrice();
    this.updateMasterId();
    //this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    if (!this.currentVariant) { 
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
    
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

   // const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
    //mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true);

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });

    document.querySelectorAll('.popupModal').forEach(function(modal){
      modal.style.display='none';      
    })
   if(document.querySelector('.pop-up-section-variant-'+this.currentVariant.id)){ document.querySelector('.pop-up-section-variant-'+this.currentVariant.id).style.display=''; }
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() { 
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);
        //console.log(this.currentVariant.id);
      let variantJSON = JSON.parse(document.querySelector("#variantMetaJson").innerHTML);
      let variantJSONNew=Object.values(variantJSON);
      const productForm = document.getElementById(`product-form-${this.dataset.section}`);
      const addButton = productForm.querySelector('[name="add"]');
      const addButtonText = productForm.querySelector('[name="add"] > span');
      let filterValue =variantJSONNew.find(variant =>variant.variantId == this.currentVariant.id);
      if(filterValue) { //console.log("filterValue",filterValue)
      var perMlPrice = (filterValue.variantPrice / filterValue.perMLPrice).toFixed(2) ;
      if(filterValue.perMLPrice != null && filterValue.perMLPrice != '' && document.querySelector('#priceMLPrice')) { document.querySelector('#priceMLPrice').innerHTML=perMlPrice; }
      var eddSku = filterValue.variantSku;
      var eddHide = filterValue.eddhide;
      var preOrder = filterValue.preorder; 
      var disableCart = filterValue.disablecart; 
      var klaviyoId = filterValue.klaviyoid; 
      var enableNotify = filterValue.enablenotify; 
      var hideBuyNow = filterValue.hidebuynow; 
      var soldOutLabel = filterValue.soldoutlabel; 
      var deliveryMessage = filterValue.delivery; 
      var available = filterValue.available; 
      var klaviyoId=filterValue.klaviyoid; 
      if(eddHide == "true" && document.querySelector(".clickpost-edd__container")){document.querySelector(".clickpost-edd__container").style.display = "none"; }
      else { if(document.querySelector(".clickpost-edd__container")){document.querySelector(".clickpost-edd__container").style.display = "block"; }}

      if(preOrder =="true" && available =='true' && disableCart == "false" && enableNotify == "false") {
      document.querySelector('#addToCart').classList.remove("hidden-button");addButton.removeAttribute('disabled');
      document.querySelector(".updateBtnText").innerHTML=window.variantStrings.preorder;
      document.querySelector('.external-payment-button').classList.add("hidden-button");
        
     if( document.querySelector("#outSideIndia").value == "true" && hideBuyNow == "false") {
     document.querySelector(".native_eight2e_checkout").classList.remove("hidden-button");
     document.querySelector(".native_eight2e_checkout").style.display = "block";
     document.querySelector('.shopify-payment-button').classList.remove("visually-hidden");
     }
    } 
      
    if(disableCart == "true" && enableNotify == "false") { document.querySelector('.native_eight2e_checkout').classList.add("hidden-button"); document.querySelector('#addToCart').classList.remove("hidden-button"); addButton.setAttribute('disabled', 'disabled'); if(soldOutLabel !=''){addButtonText.textContent = soldOutLabel; } else {addButtonText.textContent = window.variantStrings.soldOut;} }

    if(preOrder =="false" && available =='true' && disableCart == "false" && enableNotify == "false") {
    document.querySelector('#addToCart').classList.remove("hidden-button");
    addButton.removeAttribute('disabled');
    addButtonText.textContent = window.variantStrings.addToCart;
    if(document.querySelector("#outSideIndia") && document.querySelector("#outSideIndia").value == "true" && hideBuyNow == "false") {
    document.querySelector(".native_eight2e_checkout").classList.remove("hidden-button");
    document.querySelector(".native_eight2e_checkout").style.display = "block";
    document.querySelector('.shopify-payment-button').classList.remove("visually-hidden");
    
    }
                                                                                                      }  
   
    if( enableNotify == "true" && klaviyoId != '' ) { 
    document.querySelector('.klaviyo_form_trigger').classList.remove("hidden-button");  
    document.querySelector('.klaviyo_form_trigger').setAttribute('id',eddSku);
    document.querySelector('#addToCart').classList.add("hidden-button");  
    document.querySelector(".native_eight2e_checkout").classList.add("hidden-button");
                          document.querySelector('.klaviyo_form_trigger').addEventListener('click', function (){
                                   window._klOnsite = window._klOnsite || [];
                                   window._klOnsite.push(['openForm', klaviyoId]);
                          });                      
    }
    else {
     document.querySelector('.klaviyo_form_trigger').classList.add("hidden-button"); 
    }

  if( enableNotify == "false" && available =='false') { document.querySelector('#addToCart').classList.remove("hidden-button"); addButton.setAttribute('disabled', 'disabled'); if(soldOutLabel !=''){addButtonText.textContent = soldOutLabel; } else {addButtonText.textContent = window.variantStrings.soldOut;} document.querySelector('.external-payment-button').classList.add("hidden-button");}
      
  if((hideBuyNow == "true" || disableCart == "true") && document.querySelector('.external-payment-button')) { document.querySelector('.external-payment-button').classList.add("hidden-button");}   

  if((hideBuyNow == "true" || disableCart == "true") && document.querySelector("#outSideIndia") && document.querySelector("#outSideIndia").value == "true" && document.querySelector('.native_eight2e_checkout')) { document.querySelector('.native_eight2e_checkout').classList.add("hidden-button");document.querySelector(".native_eight2e_checkout").style.display = "none"; } 
      
  if(hideBuyNow == "false" && disableCart == "false" && available == "true" ) {
   document.querySelector('#addToCart').classList.remove("hidden-button"); 
   addButtonText.textContent = window.variantStrings.addToCart;
  if(document.querySelector('.external-payment-button')){
  document.querySelector('.external-payment-button').classList.remove("hidden-button"); 
  }
  else {
  document.querySelector(".native_eight2e_checkout").classList.remove("hidden-button"); 
  document.querySelector(".native_eight2e_checkout .shopify-payment-button").classList.remove("visually-hidden"); 
  }
  }   
    
      }
        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;
  /*
    if (disable) {  
      addButton.setAttribute('disabled', 'disabled');
      if(document.querySelector('.shopify-payment-button')){ document.querySelector('.shopify-payment-button').classList.add("hidden-button");}
      if(document.querySelector('.klaviyo_form_trigger')){document.querySelector('.klaviyo_form_trigger').classList.remove("visually-hidden");}
      if (text) addButtonText.textContent = text;
    } else {  
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
       if(document.querySelector('.shopify-payment-button')){document.querySelector('.shopify-payment-button').classList.remove("visually-hidden");}
       if(document.querySelector('.klaviyo_form_trigger')){document.querySelector('.klaviyo_form_trigger').classList.add("visually-hidden"); }
    }
*/
    if (!modifyClass) return;
  }
  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    const productSize_text = Array.from(this.getElementsByClassName('product_size'))[0];
  
    this.options = fieldsets.map((fieldset,index) => {
    const productSize = Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    var eddHide= Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).getAttribute('data-eddhide');
    if(eddHide == "true" && document.querySelector(".clickpost-edd__container")){document.querySelector(".clickpost-edd__container").style.display = "none"; }
    else { if(document.querySelector(".clickpost-edd__container")){document.querySelector(".clickpost-edd__container").style.display = "block"; }}
      
    var available= Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).getAttribute('data-available');
    var preOrder= Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).getAttribute('data-preorder');
  
    var disableCart= Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).getAttribute('data-disablecart');
    var klaviyoId= Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).getAttribute('data-klaviyoid');
    var enableNotify= Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).getAttribute('data-enablenotify');
    var hideBuyNow= Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).getAttribute('data-hidebuynow');
    var soldOutLabel= Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).getAttribute('data-soldoutlabel');
      
   /* if(preOrder =="true" && available =='true' && disableCart == "false" && enableNotify == "false") {  document.querySelector('#addToCart').classList.remove("hidden-button");addButton.removeAttribute('disabled');   document.querySelector(".updateBtnText").innerHTML=window.variantStrings.preorder; document.querySelector('.external-payment-button').classList.add("hidden-button");
                                                                                                    if( document.querySelector("#outSideIndia").value == "true" && hideBuyNow == "false") {document.querySelector(".native_eight2e_checkout").classList.remove("hidden-button");document.querySelector(".native_eight2e_checkout").style.display = "block"; document.querySelector('.shopify-payment-button').classList.remove("visually-hidden");}
                                                                                                     } 
      
    if(disableCart == "true" && enableNotify == "false") { document.querySelector('#addToCart').classList.remove("hidden-button"); addButton.setAttribute('disabled', 'disabled'); if(soldOutLabel !=''){addButtonText.textContent = soldOutLabel; } else {addButtonText.textContent = window.variantStrings.soldOut;} }

    if(preOrder =="false" && available =='true' && disableCart == "false" && enableNotify == "false") { document.querySelector('#addToCart').classList.remove("hidden-button"); addButton.removeAttribute('disabled'); addButtonText.textContent = window.variantStrings.addToCart;
    if( document.querySelector("#outSideIndia") && document.querySelector("#outSideIndia").value == "true" && hideBuyNow == "false") {document.querySelector(".native_eight2e_checkout").classList.remove("hidden-button");document.querySelector(".native_eight2e_checkout").style.display = "block"; document.querySelector('.shopify-payment-button').classList.remove("visually-hidden");}
                                                                                                      }  
   
    if( enableNotify == "true" && klaviyoId != '' ) { 
    document.querySelector('.klaviyo_form_trigger').classList.remove("hidden-button");  
    document.querySelector('#addToCart').classList.add("hidden-button");  
    document.querySelector(".native_eight2e_checkout").style.display = "none";
                          document.querySelector('.klaviyo_form_trigger').addEventListener('click', function (){
                                   window._klOnsite = window._klOnsite || [];
                                   window._klOnsite.push(['openForm', klaviyoId]);
                          });                      
    } else {
     document.querySelector('.klaviyo_form_trigger').classList.add("hidden-button"); 
     document.querySelector('#addToCart').classList.remove("hidden-button");   
    }
  // if( (disableCart == "false" && available =="true") || (available == "false" && enableNotify == "true")) {
  // document.querySelector('.klaviyo_form_trigger').classList.add("hidden-button");   
  // }
  if( enableNotify == "false" && available =='false') { document.querySelector('#addToCart').classList.remove("hidden-button"); addButton.setAttribute('disabled', 'disabled'); if(soldOutLabel !=''){addButtonText.textContent = soldOutLabel; } else {addButtonText.textContent = window.variantStrings.soldOut;} document.querySelector('.external-payment-button').classList.add("hidden-button");}
      
  if((hideBuyNow == "true" || disableCart == "true") && document.querySelector('.external-payment-button')) { document.querySelector('.external-payment-button').classList.add("hidden-button");}   

  if((hideBuyNow == "true" || disableCart == "true") && document.querySelector("#outSideIndia") && document.querySelector("#outSideIndia").value == "true" && document.querySelector('.native_eight2e_checkout')) { document.querySelector('.native_eight2e_checkout').classList.add("hidden-button");document.querySelector(".native_eight2e_checkout").style.display = "none"; } 
      
  if(hideBuyNow == "false" && disableCart == "false" && available == "true" && document.querySelector('.external-payment-button')) { document.querySelector('.external-payment-button').classList.remove("hidden-button");}   
  
  var deliveryMessage= Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).getAttribute('data-delivery');
  if(document.querySelector('.delivery_message')){if(deliveryMessage !=''){ document.querySelector('.delivery_message').innerHTML= deliveryMessage} else {document.querySelector('.delivery_message').innerHTML=''; } }
*/    
   productSize_text.innerHTML = productSize;
   //one liner code for size Text that is move below the title from variant option 28SEPT2023
       const selector = `.moveToTitle_${index} .product_size`
      document.querySelector(selector).innerHTML = productSize;
      return productSize;
    });

  }
  
  updateTaxPrice() {
    const taxList = document.getElementsByClassName('tax-list');
   if(taxList.length > 0){
     taxList.forEach((evt) => {
      if(this.options[0] == evt.getAttribute('data-variant-size')) {
        evt.removeAttribute("hidden");
      } else {
        evt.hidden = true;
      }
    })
   }
  }
}


customElements.define('variant-radios', VariantRadios);



class CartVariantRadios extends HTMLElement {
  constructor() {
    super();
     this.addEventListener('change', this.onVariantChange);
  }
  onVariantChange() { 
  this.updateOptions();
  this.updateMasterId();
      if (!this.currentVariant) { 
      // this.toggleAddButton(true, '', true);
      // this.setUnavailable();
    } else { //console.log("featM",this.currentVariant)
      if(this.currentVariant.featured_image){document.querySelector("#cart-item__image_"+this.currentVariant.featured_image.product_id).setAttribute('src',this.currentVariant.featured_media.preview_image.src);}
      this.updateVariantInput();
     // this.renderProductInfo();
    }
  }
  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => { 
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }
   updateVariantInput() {
     var price= this.currentVariant.price;
     document.querySelector("#variantMiniPrice_"+this.currentVariant.featured_image.product_id).innerHTML="₹ "+formatCurrency(price/100);
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }
 
 getVariantData() {
   console.log(this.variantData)
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
  updateOptions() {
     const productForm = document.getElementById(`product-form-${this.dataset.section}`);
   // this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
    

    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    const productSize_text = Array.from(this.getElementsByClassName('product_size'))[0];
  
    this.options = fieldsets.map((fieldset) => {
    const productSize = Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;

    var available= Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).getAttribute('data-available');
    var preOrder= Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).getAttribute('data-preorder');
  
    var disableCart= Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).getAttribute('data-disablecart');
    var hideBuyNow= Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).getAttribute('data-hidebuynow');
    var soldOutLabel= Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).getAttribute('data-soldoutlabel');

      
    if(preOrder =="true" && available =='true' && disableCart == "false" ) {  productForm.querySelector('#add_to_cart').classList.remove("hidden-button");addButton.removeAttribute('disabled');   addButtonText.textContent= window.variantStrings.preorder; } 
      
    if(disableCart == "true") { productForm.querySelector('#add_to_cart').classList.remove("hidden-button"); addButton.setAttribute('disabled', 'disabled'); if(soldOutLabel !=''){addButtonText.textContent = soldOutLabel; } else {addButtonText.textContent = window.variantStrings.soldOut;}}

    if(preOrder =="false" && available =='true' && disableCart == "false" ) { productForm.querySelector('#add_to_cart').classList.remove("hidden-button"); addButton.removeAttribute('disabled'); addButtonText.textContent = window.variantStrings.addToCart;}
      
   if( available =='false') { productForm.querySelector('#add_to_cart').classList.remove("hidden-button"); addButton.setAttribute('disabled', 'disabled'); if(soldOutLabel !=''){addButtonText.textContent = soldOutLabel; } else {addButtonText.textContent = window.variantStrings.soldOut;}}


   productSize_text.innerHTML = productSize;

      return productSize;
    });

  }
  
  updateTaxPrice() {
    const taxList = document.getElementsByClassName('tax-list');
   if(taxList.length > 0){
     taxList.forEach((evt) => {
      if(this.options[0] == evt.getAttribute('data-variant-size')) {
        evt.removeAttribute("hidden");
      } else {
        evt.hidden = true;
      }
    })
   }
  }
}


customElements.define('cart-variant-radios', CartVariantRadios);

function closeDialog(){
document.querySelectorAll('.Toastify_popup').forEach(function(popup){popup.classList.remove('Toastify_popup_open')});  
}
function formatCurrency(number) {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}